import client, { handleError, formUploadConfig, noLoadingConfig } from '../axios-config'

const controllerPrefix = '/tenant'

const getOptOutList = async function (crmId) {
  try {
    const response = await client.get(`${controllerPrefix}/optOut/list/${crmId}`, noLoadingConfig)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

const createOptOut = async function (data) {
  try {
    const response = await client.post(`${controllerPrefix}/optOut/create`, data, noLoadingConfig)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

const setOptOutValue = async function (optOutId, prop, value) {
  try {
    const response = await client.post(`${controllerPrefix}/optOut/${prop}`, { id: optOutId, value: value !== undefined && value !== null ? value.toString() : value }, noLoadingConfig)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

const uploadOptOutLogo = async function (data) {
  try {
    const response = await client.post(`${controllerPrefix}/optOut/uploadLogo`, data, formUploadConfig)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}

const deleteOptOut = async function (optOutId) {
  try {
    const response = await client.delete(`${controllerPrefix}/optOut/delete/${optOutId}`, noLoadingConfig)
    return response.data
  } catch (error) {
    return handleError(error)
  }
}
export const tenantService = {
  getOptOutList,
  createOptOut,
  setOptOutValue,
  uploadOptOutLogo,
  deleteOptOut
}
